import Folder from '../store/schema/Folder';
import FolderStore from '../store/schema/FolderStore';
import { getTreeTypeFromFolderId } from '../util/folderUtility';
import { getEffectiveFolderDisplayName } from 'owa-folders';
import folderId from 'owa-service/lib/factory/folderId';
import { action } from 'satcheljs/lib/legacy';

export function deleteFoldersFromFolderTable(state: FolderStore, folderIdsToDelete: string[]) {
    // delete each folder from local store
    folderIdsToDelete.forEach(folderId => {
        state.folderTable.delete(folderId);
    });
}

export let removeFolderFromParentFolder = action('removeFolderFromParentFolder')(
    function removeFolderFromParentFolder(state: FolderStore, folderToMove: Folder) {
        if (!folderToMove.ParentFolderId) {
            return;
        }

        let childFolderIds = state.folderTable.get(folderToMove.ParentFolderId.Id).childFolderIds;
        childFolderIds.splice(childFolderIds.indexOf(folderToMove.FolderId.Id), 1);
    }
);

export function addFolderInSortedOrderUnderParentFolder(
    folder: Folder,
    state: FolderStore,
    parentFolderId: string
): void {
    // Try to insert the folder in the alphabetically most optimal place.
    // The server will do some better alphabetical server-side sorting, but this
    // is good enough and it covers 90% of the languages and cases.
    let childFolderIds: string[] = state.folderTable.get(parentFolderId).childFolderIds;
    let added: boolean = false;
    let displayNameLowerCase = getEffectiveFolderDisplayName(folder).toLowerCase();

    for (let i = 0; i < childFolderIds.length && !added; i++) {
        let childFolder = state.folderTable.get(childFolderIds[i]);

        // Insert item in position i, if it is next in alphabetical order.
        if (getEffectiveFolderDisplayName(childFolder).toLowerCase() > displayNameLowerCase) {
            childFolderIds.splice(i, 0, folder.FolderId.Id);
            added = true;
        }
    }

    // Append at the end if needed.
    if (!added) {
        childFolderIds.push(folder.FolderId.Id);
    }
}

export let moveFolderToParentFolder = action('moveFolderToParentFolder')(
    function moveFolderToParentFolder(
        state: FolderStore,
        folderToMove: Folder,
        destinationFolderId: string
    ) {
        addFolderInSortedOrderUnderParentFolder(folderToMove, state, destinationFolderId);
        folderToMove.ParentFolderId = folderId({ Id: destinationFolderId });
        folderToMove.treeType = getTreeTypeFromFolderId(destinationFolderId);
    }
);
